<template>
  <form class="lar_form">
    <form-row>
      <div class="col">
        <h3 class="form_section_title">
          基本資料
        </h3>
      </div>
    </form-row>
    <form-row>
      <form-group
        class="col-md-3 col-sm-12"
        label="公司名稱"
      >
        <input-group>
          <form-input
            v-model="enterprise.enterprise_name"
            name="enterprise-name"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
      <form-group
        class="col-md-3 col-sm-12"
        label="負責人"
      >
        <input-group>
          <form-input
            v-model="enterprise.enterprise_owner"
            name="enterprise-owner"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
      <form-group
        class="col-md-3 col-sm-12"
        label="成立時間"
      >
        <date-time-picker
          v-model="enterprise.enterprise_founded_date"
          input-name="founded-date"
          :max-datetime="$moment().toISOString(true)"
          format="yyyy/LL/dd"
          read-only
        >
          <span
            slot="before"
            aria-hidden="true"
            class="input-group-text text-muted btn-pill"
          >
            <font-awesome-icon icon="calendar-alt" />
          </span>
        </date-time-picker>
      </form-group>
      <form-group
        class="col-md-3 col-sm-12"
        label="員工人數"
      >
        <input-group>
          <form-input
            v-model="enterprise.enterprise_employee_number"
            type="number"
            name="enterprise-employee-number"
            readonly
          />
        </input-group>
      </form-group>
    </form-row>
    <form-row>
      <form-group
        class="col-md-6 col-sm-12"
        label="公司網址"
      >
        <input-group>
          <form-input
            v-model="enterprise.enterprise_website"
            name="enterprise-website"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
      <form-group
        class="col-md-6 col-sm-12"
        label="產業類別"
      >
        <input-group>
          <form-select
            :default-value="enterprise.enterprise_industry"
            :options="categoriesGetter"
            select-name="category_name"
            select-value="category_value"
            name="enterprise-industries"
            aria-readonly="true"
            read-only
          />
        </input-group>
      </form-group>
    </form-row>
    <form-row>
      <form-group
        class="col-md-6 col-sm-12"
        label="公司地址"
      >
        <input-group>
          <form-input
            v-model="enterprise.enterprise_address"
            name="enterprise-address"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
      <form-group
        class="col-md-6 col-sm-12"
        label="通訊電話"
      >
        <input-group>
          <form-input
            v-model="enterprise.enterprise_tel"
            name="enterprise-tel"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
    </form-row>

    <form-row>
      <div class="col">
        <h3 class="form_section_title">
          公司簡介
        </h3>
      </div>
    </form-row>
    <form-row>
      <form-group
        class="col-md-3 col-sm-12"
        label="關係企業"
      >
        <input-group>
          <form-input
            v-model="enterprise.enterprise_related_company"
            name="enterprise-related-company"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
      <form-group
        class="col-md-9 col-sm-12"
        label="工作身份"
      >
        <input-group>
          <form-input
            v-model="enterpriseWorkers"
            name="workers"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
    </form-row>
    <form-row>
      <form-group
        class="col-md-3 col-sm-12"
        label="工作時段"
      >
        <input-group>
          <form-input
            v-model="enterpriseWorkSessions"
            name="work-sessions"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
      <form-group
        v-for="(shift, index) in enterprise.enterprise_shift_schedule"
        :key="index"
        class="col-sm-4 col-12"
        label=" "
      >
        <time-picker
          v-model="enterprise.enterprise_shift_schedule[index]"
          input-name="start-time"
          aria-readonly="true"
          readonly
        />
      </form-group>
    </form-row>
    <form-row>
      <form-group
        cols="12"
        label="營業項目"
      >
        <input-group>
          <form-textarea
            v-model="enterprise.enterprise_services"
            :max-length="100"
            :rows="2"
            name="enterprise-services"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
    </form-row>
    <form-row>
      <form-group
        cols="12"
        label="薪資福利"
      >
        <input-group>
          <form-textarea
            v-model="enterprise.enterprise_employee_benefits"
            :max-length="100"
            :rows="2"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
    </form-row>
    <form-row>
      <form-group
        cols="12"
        label="教育訓練"
      >
        <input-group>
          <form-textarea
            v-model="enterprise.enterprise_employee_training_introduction"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
    </form-row>
    <form-row>
      <form-group
        cols="12"
        label="徵才內容"
      >
        <input-group>
          <form-textarea
            v-model="enterprise.enterprise_recruiting_description"
            :max-length="100"
            :rows="2"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
    </form-row>
    <form-row>
      <div class="col">
        <h3 class="form_section_title">
          應徵方式
        </h3>
      </div>
    </form-row>
    <form-row>
      <form-group
        class="col-md-6 col-sm-12"
        label="聯絡人"
      >
        <input-group>
          <form-input
            v-model="enterprise.enterprise_hr_contact_person"
            name="hr-contact-person"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
      <form-group
        class="col-md-6 col-sm-12"
        label="聯絡電話"
      >
        <input-group>
          <form-input
            v-model="enterprise.enterprise_hr_contact_tel"
            name="hr-contact-tel"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
    </form-row>
    <form-row>
      <form-group
        cols="12"
        label="電子信箱"
      >
        <input-group>
          <form-input
            v-model="enterprise.enterprise_hr_contact_email"
            name="hr-contact-email"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
    </form-row>
    <form-row>
      <form-group
        cols="12"
        label="準備資料"
      >
        <input-group>
          <form-textarea
            v-model="enterprise.enterprise_work_portfolio"
            :max-length="100"
            :rows="2"
            aria-readonly="true"
            readonly
          />
        </input-group>
      </form-group>
    </form-row>
    <template v-if="enterprise.enterprise_hire_foreigners">
      <form-section-divider />
      <form-row>
        <div class="col">
          <h3 class="form_section_title">
            英文版 - 提供外籍人士職缺
          </h3>
        </div>
      </form-row>
      <form-row>
        <form-group
          class="col-sm-4 col-12"
          label="Corporation"
        >
          <input-group>
            <form-input
              v-model="enterprise.enterprise_name_en"
              name="enterprise_name_en"
              aria-readonly="true"
              readonly
            />
          </input-group>
        </form-group>
        <form-group
          class="col-sm-4 col-12"
          label="Related Corporation"
        >
          <input-group>
            <form-input
              v-model="enterprise.enterprise_related_company_en"
              name="enterprise_related_company_en"
              aria-readonly="true"
              readonly
            />
          </input-group>
        </form-group>
        <form-group
          class="col-sm-4 col-12"
          label="Contact"
        >
          <input-group>
            <form-input
              v-model="enterprise.enterprise_hr_contact_person_en"
              name="contact-person-en"
              aria-readonly="true"
              readonly
            />
          </input-group>
        </form-group>
      </form-row>
      <form-row>
        <form-group
          cols="12"
          label="Address"
        >
          <input-group>
            <form-input
              v-model="enterprise.enterprise_address_en"
              name="address-en"
              aria-readonly="true"
              readonly
            />
          </input-group>
        </form-group>
      </form-row>
      <form-row>
        <form-group
          class="col-sm-6 col-12"
          label="Running Project"
        >
          <input-group>
            <form-textarea
              v-model="enterprise.enterprise_services_en"
              name="services-en"
              aria-readonly="true"
              readonly
            />
          </input-group>
        </form-group>
        <form-group
          class="col-sm-6 col-12"
          label="Salary & Welfare"
        >
          <input-group>
            <form-textarea
              v-model="enterprise.enterprise_employee_benefits_en"
              name="employee-benefits-en"
              aria-readonly="true"
              readonly
            />
          </input-group>
        </form-group>
      </form-row>
      <form-row>
        <form-group
          class="col-sm-6 col-12"
          label="Orientation"
        >
          <input-group>
            <form-textarea
              v-model="enterprise.enterprise_employee_training_introduction_en"
              name="employee-training-introduction-en"
              aria-readonly="true"
              readonly
            />
          </input-group>
        </form-group>
        <form-group
          class="col-sm-6 col-12"
          label="Requirement"
        >
          <input-group>
            <form-textarea
              v-model="enterprise.enterprise_recruiting_description_en"
              name="recruiting-description-en"
              aria-readonly="true"
              readonly
            />
          </input-group>
        </form-group>
      </form-row>
    </template>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormRow from '~components/common/form/Row'
import FormGroup from '~components/common/form/Group'
import FormInput from '~components/common/form/input'
import InputGroup from '~components/common/form/input/Group'
import ButtonWrapper from '~components/common/buttons'
import FormSelect from '~components/common/form/Select'
import CheckInput from '~components/common/form/input/Check'
import FormTextarea from '~components/common/form/input/Textarea'
import TimePicker from '~components/third-party/larvata/TimePicker'
import DateTimePicker from '~lar/DateTimePicker'
import FormSectionDivider from '~components/common/form/section/Divider'
export default {
  name: 'SpecialIssueFormReadOnly',
  components: {
    FormRow,
    FormGroup,
    FormInput,
    InputGroup,
    FormSelect,
    CheckInput,
    FormTextarea,
    DateTimePicker,
    TimePicker,
    ButtonWrapper,
    FormSectionDivider
  },
  props: {
    specialIssue: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      enterprise: {
        enterprise_is_nine_to_five: true,
        enterprise_shift_schedule: [{
          start_time: this.$moment().format('YYYY-MM-DD HH:mm'),
          end_time: this.$moment().format('YYYY-MM-DD HH:mm')
        }],
        enterprise_is_shift_work: false,
        enterprise_is_flextime: false,
        enterprise_hire_interns: false,
        enterprise_hire_foreigners: false,
        enterprise_hire_disabled_people: false
      }
    }
  },
  computed: {
    ...mapGetters('pages/jobs', [
      'categoriesGetter'
    ]),
    enterpriseWorkSessions () {
      let result = []
      if (this.enterprise.enterprise_is_shift_work) {
        result.push('輪班')
      } else {
        result.push('日班')
        if (this.enterprise.enterprise_is_flextime) {
          result.push('彈性上下班')
        }
      }
      return result.join(', ')
    },
    enterpriseWorkers () {
      let result = []
      if (this.enterprise.enterprise_hire_interns) {
        result.push('提供實習機會')
      }
      if (this.enterprise.enterprise_hire_foreigners) {
        result.push('提供外籍人士職缺')
      }
      if (this.enterprise.enterprise_hire_disabled_people) {
        result.push('提供身心障礙職缺')
      }
      return result.join(', ')
    }
  },
  watch: {
    specialIssue (value) {
      this.enterprise = Object.assign({}, this.enterprise, value)
    }
    // enterprise (value) {
    //   this.$emit('input', value)
    // }
  },
  async created () {
    await this.getCategories()
    this.enterprise = Object.assign(
      {},
      this.specialIssue
    )
  },
  methods: {
    ...mapActions('pages/jobs', [
      'getCategories'
    ])
    // industrySelected (industry) {
    //   Object.assign({}, this.enterprise, {
    //     enterprise_industry: industry.category_value
    //   })
    // },
    // foundedDateSelected ({ startDate }) {
    //   Object.assign({}, this.enterprise, {
    //     enterprise_founded_date: startDate
    //   })
    // },
    // updateIsShift (isChecked) {
    //   if (isChecked) {
    //     this.enterprise.enterprise_is_nine_to_five = this.enterprise.enterprise_is_flextime = false
    //   }
    // },
    // updateIsNineToFive (isChecked) {
    //   if (isChecked) {
    //     this.enterprise.enterprise_is_shift_work = false
    //   }
    // },
    // addShift () {
    //   this.enterprise.enterprise_shift_schedule.push({
    //     start_time: this.$moment().format('YYYY-MM-DD HH:mm'),
    //     end_time: this.$moment().format('YYYY-MM-DD HH:mm')
    //   })
    // },
    // removeShift (index) {
    //   this.enterprise.enterprise_shift_schedule.splice(index, 1)
    // }
  }
}
</script>